import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#0f0f0f]"
        data-testid="auth-loading-screen"
      >
        <div className="flex flex-col items-center gap-4" data-testid="auth-loading-indicator">
          <div className="h-10 w-10 rounded-full border-2 border-[#dfa625] border-t-transparent animate-spin" />
          <p className="text-white/70 text-xs tracking-[0.18em] uppercase" data-testid="auth-loading-caption">
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
